<template>
  <!-- Portfolio Grid-->
  <section class="page-section bg-light" id="portfolio">
    <div class="container">
      <div class="text-center">
        <h2 class="section-heading text-uppercase" id="pageTitle">Search our database</h2>
        <h3 class="section-subheading text-muted">Looking if a certain artist or track has ever made it to one of our shows ?</h3>
      </div>
      <div class="row mb-2">
        <div class="col-lg-12">
          <form class="form-inline d-flex justify-content-center" v-on:submit.prevent="onSubmit">
            <input type="text" v-model="term" class="form-control mb-2 mr-sm-2 col-lg-6" />
            <!-- <button class="btn btn-primary mb-2 mr-sm-2" type="submit">Search</button> -->
          </form>
        </div>
      </div>
      <div v-if="$apollo.loading && term.length > 3" class="text-center"><strong>loading ...</strong></div>
      <div v-else-if="term.length > 0 && term.length < 4" class="text-center">Type some more...</div>
      <div class="row" v-else-if="!$apollo.loading && term.length > 3 && shows.length">
        <show-teaser v-for="(show, index) in shows" :key="index" :show="show"></show-teaser>
      </div>
      <div class="row text-center" v-else-if="term.length > 3 && ! shows.length ">
        <div class="col-lg-12">No results for {{term}}</div>
      </div>
    </div>
  </section>
</template>

<script>

import gql from "graphql-tag";
import showTeaser from "./showTeaser";
import _ from "lodash";

export default {
  name: "search",

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "blackmondayradio.nl - Metal op de radio ! - Search",
  },

  components: {
    showTeaser,
  },
  data: function () {
    return {
      tracks: [],
      term: "",
    };
  },
  methods: {
    onSubmit: function () {
      return false;
    },
  },
  computed: {
    
    shows: function () {
      let results = [];
      _.each(this.tracks.data, function (track) {
        _.each(track.playlists, function (playlist) {
          results.push(playlist);
        });
      });
      return results;
    },
    parsedTerm: function () {
      return (this.term.length > 3) ? "%" + this.term + "%": null;
    },
  },
  apollo: {
    tracks: {
      query: gql`
        query($term: Mixed) {
          tracks(
            where: {
              OR: [
                { column: TRACK, operator: LIKE, value: $term }
                { column: ARTIST, operator: LIKE, value: $term }
              ]
            }
          ) {
            data {
              artist
              track
              playlists {
                id
                title
                djs
                image
                dateTimeBroadcast
                date_on_air
                url_mixcloud
              }
            }
          }
        }
      `,
      variables: function () {
        return {
          term: this.parsedTerm,
        };
      }
    },
  },
};
</script>